import { translate as t } from '@thoughtspot/i18n';
import { create } from '@thoughtspot/logger';
import { TSToChartEvent, } from '@thoughtspot/ts-chart-sdk';
import _ from 'lodash';
import { getErrorObject, getErrorStringForBanner, } from '../../components/chart-error/chart-error.util';
import { dispatchAxisMenuCustomAction } from './dispatch-axis-menu-actions';
import { dispatchContextMenuCustomAction } from './dispatch-context-actions';
import { dispatchGlobalAlertAction } from './dispatch-global-alert-action';
import { triggerDownloadXlsx } from './download-xlsx-triggered';
import { getColumnData } from './get-column-data';
import { triggerGetDataQueriesFromAxisConfig } from './get-data-query';
import { initializeCustomChart, triggerInitializeComplete, } from './initialize-custom-chart';
import { triggerChartReRender } from './trigger-chart-re-render';
import { triggerUpdateChartModel } from './update-chart-model';
import { triggerUpdateVisualProps } from './update-visual-props';
import { validateCustomChartConfig } from './validate-chart-config';
import { validateCustomVisualProps } from './validate-visual-props';
const logger = create('EventEmitter');
const eventEmitters = {
    [TSToChartEvent.Initialize]: initializeCustomChart,
    [TSToChartEvent.InitializeComplete]: triggerInitializeComplete,
    [TSToChartEvent.TriggerRenderChart]: triggerChartReRender,
    [TSToChartEvent.ChartModelUpdate]: triggerUpdateChartModel,
    [TSToChartEvent.GetDataQuery]: triggerGetDataQueriesFromAxisConfig,
    [TSToChartEvent.VisualPropsUpdate]: triggerUpdateVisualProps,
    [TSToChartEvent.ChartConfigValidate]: validateCustomChartConfig,
    [TSToChartEvent.VisualPropsValidate]: validateCustomVisualProps,
    [TSToChartEvent.ContextMenuActionClick]: dispatchContextMenuCustomAction,
    [TSToChartEvent.AxisMenuActionClick]: dispatchAxisMenuCustomAction,
    [TSToChartEvent.GetColumnData]: getColumnData,
    [TSToChartEvent.DownloadExcelTrigger]: triggerDownloadXlsx,
    [TSToChartEvent.GlobalToastActionClick]: dispatchGlobalAlertAction,
    [TSToChartEvent.DataUpdate](commonProps, eventProps, emitEventFn) {
        throw new Error('Function not implemented.');
    },
};
export const EventEmitter = (commonProps) => {
    const { setError, chartType } = commonProps;
    const emitEvent = (eventType, eventProps) => {
        if (_.isNil(eventEmitters[eventType])) {
            logger.error('Trying to emit event that is not implemented');
            return Promise.reject(new Error('Trying to emit event that is not implemented'));
        }
        try {
            return eventEmitters[eventType](commonProps, eventProps, emitEvent);
        }
        catch (err) {
            logger.error('Error while emitting event', err);
            if (err?.errorType) {
                const errorObject = getErrorObject(err.errorType, chartType);
                if (errorObject.ErrorMsgCode !== '') {
                    setError(getErrorStringForBanner(errorObject.errorDescription, errorObject.ErrorMsgCode));
                }
                else {
                    setError(getErrorStringForBanner(errorObject.errorDescription));
                }
            }
            else {
                setError(err?.message ??
                    t('customChartErrorMessage.UNKNOWN_ERROR.title'));
            }
            return Promise.reject(err);
        }
    };
    return {
        emitEvent,
    };
};
//# sourceMappingURL=event-emitter.js.map